module.exports = __webpack_public_path__ + "static/media/email.9df37b47.svg";